<template>
  <div class="main-frame">
    <div class="info-frame">
      <van-nav-bar title="SMOK" class="top_bar" fixed @click-left="backHome()">
        <template #title>
          <img class="logo-img" src="../assets/image/smoklogo.png" />
        </template>
        <template #left>
          <van-icon name="arrow-left" size="20" color="#000" />
        </template>
      </van-nav-bar>
      <!-- 占位高度 -->
      <van-divider class="top-divider" :style="{ borderColor: '#FFF' }" />
      <van-form @submit="onSubmit">
        <!-- 用户称呼 -->
        <van-field
          class="input-field-top"
          v-model="form.user_name"
          name="user_name"
          :rules="rule.name"
          required
          clearable
          v-bind:placeholder="$t('message.inform_input_name')"
        />
        <!-- 邮箱 -->
        <van-field
          class="input-field"
          v-model="form.email"
          name="email"
          :rules="[{ validator, message: 'Incorrect email format' }]"
          required
          clearable
          v-bind:placeholder="$t('message.inform_input_email')"
        />
        <!-- 商店名称或者网址 -->
        <van-field
          class="input-field"
          v-model="form.stroe_name"
          name="stroe_name"
          :rules="rule.store_name"
          required
          clearable
          v-bind:placeholder="$t('message.inform_input_store_name')"
        />
        <!-- 商店地址 -->
        <van-field
          class="input-field"
          v-model="form.stroe_address"
          name="stroe_address"
          :rules="rule.stroe_address"
          required
          clearable
          v-bind:placeholder="$t('message.inform_input_store_address')"
        />
        <!-- 反馈的信息 -->
        <van-field
          class="input-field"
          v-model="form.feedback"
          name="feedback"
          type="textarea"
          :rules="rule.feedback"
          maxlength="1000"
          rows="3"
          required
          autosize
          show-word-limit
          v-bind:placeholder="$t('message.inform_input_feedback')"
        />
        <!-- 上传图片 - 暂时屏蔽举报上传图片 -->
        <!-- <van-uploader class="upload-image" v-model="fileList" :max-count="3" :after-read="afterRead"/> -->
        <!-- <van-field class="input-field-end" name="uploader">
          <template #input>
            <van-uploader v-model="uploader" />
          </template>
        </van-field>-->
        <!-- 举报按钮 -->
        <van-button
          class="activate-btn"
          type="info"
          color="#30b3f0"
          native-type="submit"
          >{{ $t("message.inform_input_submit") }}</van-button
        >
      </van-form>
    </div>
    <div class="bottom-view">
      <!-- 装饰线条 -->
      <img class="img-margin" src="../assets/image/footer.png" />
      <!-- 版权说明 -->
      <foot></foot>
    </div>
  </div>
</template>

<script>
import foot from "@/components/Foot.vue";
export default {
  components: {
    foot,
  },
  name: "inform",
  data() {
    return {
      text: {},
      fileList: [],
      form: {
        user_name: "",
        email: "",
        stroe_name: "",
        stroe_address: "",
        feedback: "",
      },
      rule: {
        name: [{ required: true, message: "Please fill in the name" }],
        store_name: [
          { required: true, message: "Please fill in the store name & website" },
        ],
        store_address: [{ required: true, message: "Please fill in the Store address" }],
        feedback: [{ required: true, message: "Please fill in the Feedback content" }],
      },
      uploadList: [],
    };
  },
  created() {
    if (this.$route.params.data != undefined) {
      this.text = this.$route.params.data;
    } else {
      // 返回主页
      this.$notify(this.$t("message.home_model_not_scanner_code_a"));
      this.$router.push({ name: "bind-home" });
    }
  },
  methods: {
    backHome() {
      this.$router.push({ name: "bind-home" });
      // this.$router.go(-1);
    },
    validator(val) {
      return /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(val);
    },
    onSubmit(values) {
      // console.log(values);

      this.$toast.loading({
        message: "Loading...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });

      let _me = this;
      // console.log(_me.form);
      let params = {
        type: 6,
        name: values.user_name,
        email: values.email,
        business_name: values.stroe_name,
        business_address: values.stroe_address,
        reason: values.feedback,
        info_code: this.text.info_code != undefined ? this.text.info_code : "",
        activation_code:
          this.text.activation_code != undefined ? this.text.activation_code : "",
      };
      this.common
        .httpPost("report/add", params)
        .then((res) => {
          _me.$toast.clear();
          // console.log(res)
          if (res.code == 100000) {
            _me.$notify({
              type: "success",
              message:
                "Thank you for your feedback and we will process your feedback immediately.",
            });
            this.$router.push({ name: "bind-home" });
          } else {
            _me.$notify(res.message);
          }
        })
        .catch((err) => {
          _me.$toast.clear();
          _me.$notify("Get Web Data Error:", err.toString());
        });
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "The file format is incorrect",
        desc: "File format of " + file.name + " is incorrect, please select jpg or png.",
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "Exceeding file size limit",
        desc: "File  " + file.name + " is too large, no more than 2M.",
      });
    },
    handleRemove(file) {
      this.uploadList.splice(this.uploadList.indexOf(file), 1);
    },
    handleUpload(file) {
      // 上传文件前的事件钩子
      let reader = new FileReader();
      // 读取文件作为 URL 可访问地址
      reader.readAsDataURL(file);
      const _this = this;
      // eslint-disable-next-line
      reader.onloadend = function (e) {
        // console.log(reader.result);
        file.url = reader.result;
        _this.uploadList.push(file);
      };
      return false;
    },
  },
};
</script>

<style scoped>
.main-frame {
  /*width: 100%;*/
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background-color: white;
  text-align: center;
}

.info-frame {
  flex: 1;
}

.top_bar {
  height: 54px;
}

.logo-img {
  margin-top: 4px;
  height: 24px;
}

.top-divider {
  background-color: white;
  margin: 0;
  height: 55px;
}

.input-field-top {
  margin-left: 16px;
  margin-top: 16px;
  font-size: 12pt;
  width: calc(100% - 32px);
  background-color: #f5f5f5;
  border-radius: 4px;
}

.input-field {
  margin-left: 16px;
  margin-top: 8px;
  font-size: 12pt;
  width: calc(100% - 32px);
  background-color: #f5f5f5;
  border-radius: 4px;
}

.van-cell::after {
  content: none;
}

.upload-image {
  margin-top: 16px;
  margin-left: 16px;
  width: calc(100% - 32px);
  font-size: 12pt;
  float: left;
  padding: 0;
}

.activate-btn {
  margin-top: 20px;
  font-size: 14pt;
  width: calc(100% - 32px);
  border-radius: 8px;
}

.img-margin {
  width: 100%;
  height: 22px;
}

.bottom-view {
  min-height: 50px;
  margin-top: 20px;
  background-color: white;
}
</style>
